import React, { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
  GetAll,
} from "../../../../features/admin/master/customer_booking_tnc/Slice";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { Controller, useForm } from "react-hook-form";
import JoditEditor from "jodit-react";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";
import Reject_Modal from "../../../common-components/common_Modal/Reject_Modal/Reject_Modal";
import Add_section_title from "../../../common-components/add-section-title/Add_section_title";

const Add = ({ id, setId, setShowError, setSuccess, setErr }) => {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();
  const [rejectModalShow, setRejectModalShow] = React.useState(false);

  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    getValues,
    control,
    watch,
    formState: { errors },
    reset,
    trigger,
  } = useForm();
  const nameValue = watch("name");

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      if (res.meta.requestStatus === "fulfilled") {
        reset(res?.payload?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (id !== "") {
      GetData(id);
    }
  }, [id]);

  const onSubmit = async (data) => {
    try {
      let response;
      if (id) {
        response = await dispatch(Update({ id, data }));
      } else {
        response = await dispatch(Create(data));
      }
      if (response.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        await setId("");
        setSuccess(true);
        setModalShow(true);
        reset({ name: "", type: "", description: "" });
        setTimeout(() => {
          setSuccess(false);
          setModalShow(false);
        }, 3000);
      } else if (response.meta?.requestStatus === "rejected") {
        setShowError(response.payload?.response?.data?.errors);
        setRejectModalShow(true);
        setTimeout(() => {
          setRejectModalShow(false);
        }, 3000);
      }
    } catch (error) {
      setErr(true);
      console.error("error in Add Terms and Condition", error);
    }
  };

  const typeOptions = [
    { value: "Transport", label: "Transport" },
    { value: "Cab", label: "Cab" },
    { value: "Share", label: "Share" },
  ];
  return (
    <>
      <Add_section_title
        title={
          id
            ? "Edit Booking Terms And Condition"
            : "Add Booking Terms And Condition"
        }
        alltotal=""
      />
      <div className="forms_section">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name=""
              placeholder="Name"
              {...register("name", {
                required: "Name is Required",
              })}
              className={classNames("", {
                "is-invalid": errors?.name,
              })}
            />
            {errors.name && (
              <span className="text-danger">{errors.name?.message}</span>
            )}
          </div>

          <div className="form-group">
            <Form.Label>Description</Form.Label>
            <Form.Control
              type="text"
              name=""
              placeholder="Description"
              {...register("description", {
                required: "Description is Required",
              })}
              className={classNames("", {
                "is-invalid": errors?.description,
              })}
            />
            {errors.description && (
              <span className="text-danger">{errors.description?.message}</span>
            )}
          </div>

          <div className="form-group">
            <Form.Label>Type</Form.Label>

            <Controller
              name="type"
              control={control}
              defaultValue={null}
              rules={{
                required: "Type is required",
              }}
              render={({ field }) => (
                <Select
                  options={typeOptions}
                  placeholder="Select Type"
                  value={
                    typeOptions.find(
                      (option) => option.value === field.value,
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    field.onChange(selectedOption?.value || "")
                  }
                  isClearable
                  classNamePrefix="react-select"
                />
              )}
            />

            {errors.type && (
              <span className="text-danger">{errors.type?.message}</span>
            )}
          </div>

          <div className="form_submit_div ">
            <div className="row">
              <div className="col-lg-4 mx-auto mb-3">
                <div className="button_group">
                  <button
                    type="button"
                    className="closebtn theme_bg"
                    onClick={() => {
                      reset({ name: "" });
                      setId("");
                    }}
                  >
                    Clear
                  </button>
                  <button type="submit" className="addbtn">
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>

      <Successfull_Modal
        message={"Booking Terms and Condition Added Successfully"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <Reject_Modal
        message={"Booking Terms and Condition Already Exist"}
        show={rejectModalShow}
        onHide={() => setRejectModalShow(false)}
      />
    </>
  );
};

export default Add;
